import React, { useEffect, useState } from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";
import { SectionModel } from "../../../models/components.model";
import { DocumentUrl, Factor } from "../../../models/cartable.model";
import FactorItems from "./factorItems";
import DetailInfoComponentThumbnail from "../../../components/detailInfo/detailInfoComponentThumbnail";

interface SchemaInfoModel {
  data?: Factor;
  documentList: DocumentUrl[];
  withoutDoc: boolean;
}
function _FactorInfo({ data, documentList, withoutDoc }: SchemaInfoModel) {
  const sections: SectionModel[] = [
    { dataKey: "factorNumber", rowCol: 3, title: "شماره فاکتور" },
    { dataKey: "deliveryDate_Persian", rowCol: 3, title: "تاریخ تحویل کالا" },
    { dataKey: "factorDate_Persian", rowCol: 3, title: "تاریخ صدور فاکتور" },
    { dataKey: "deliveryTime", rowCol: 3, title: "ساعت تحویل کالا" },
  ];

  return (
    <DetailInfoComponentThumbnail
      sections={sections}
      data={data}
      documentList={documentList}
      height={"20vh"}
      showFooter={true}
      title={true}
      showDoc={withoutDoc}
    />
  );
}

export default function FactorInfo(props: any) {
  let documentUrlList = [] as DocumentUrl[];
  if (props.data.factorFile != undefined) {
    documentUrlList[0] = props.data?.factorFile;
  }
  if (props.data.deliveryReceiptFile != undefined) {
    documentUrlList[1] = props.data?.deliveryReceiptFile;
  }
  const child = (
    <>
      <_FactorInfo
        data={props.data}
        documentList={documentUrlList}
        withoutDoc={props.withoutDoc}
      />
    </>
  );
  const childTwo = (
    <>
      {" "}
      <FactorItems data={props.data?.items!} totalPrice={props.data?.totalPrice!} />
    </>
  );

  const printedChild = (<>
    <_FactorInfo
      data={props.data}
      documentList={documentUrlList}
      withoutDoc={props.withoutDoc}
    />
    {" "}
    <FactorItems data={props.data?.items!} />
  </>)
  return (
    props.showInPrintMode ?
      (<DivisionCmp child={printedChild}
        title={"فاکتور فروش و تحویل کالا "} />

      ) :
      (<>
        <DivisionCmp child={child} />
        <br />
        <DivisionCmp child={childTwo} />
      </>)

  );
}
